const CANCEL_TYPE = {
    OUT_OF_STOCK: "OUT_OF_STOCK",
    DELIVERY_ISSUE: "DELIVERY_ISSUE",
    OTHERS: "OTHERS",
};

export default CANCEL_TYPE;